const editableCompViewComponentsMap = {
  jujo_grid: 'jujo_grid',
}

export default editableCompViewComponentsMap
